@layer refine.base {
  :host {
    --_dot-color: var(--typing-indicator-color, var(--_theme-base, var(--color-contrast-400)));

    display: inline-flex;
    align-items: center;
  }

  .dots {
    display: inline-flex;
    gap: var(--_gap);
    align-items: center;
  }

  .dot {
    display: inline-block;
    width: var(--_size);
    height: var(--_size);
    background: var(--_dot-color);
    border-radius: 50%;
    animation: var(--_motion-animation, typing-indicator-bounce 1.2s ease-in-out infinite);
  }

  .dot:nth-child(2) {
    animation-delay: 0.15s;
  }

  .dot:nth-child(3) {
    animation-delay: 0.3s;
  }

  @keyframes typing-indicator-bounce {
    0%,
    60%,
    100% {
      opacity: 0.4;
      transform: translateY(0);
    }

    30% {
      opacity: 1;
      transform: translateY(-35%);
    }
  }
}
